import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "label"]

  labelTargetConnected(element) {
    this.updateQuestionLabels(element)
  }

  labelTargetDisconnected() {
    this.updateQuestionLabels()
  }

  updateQuestionLabels() {
    this.labelTargets.forEach((element, index) => {
      const ogHTML = element.innerHTML
      const newHTML = ogHTML.replace("{{index}}", index + 1)
      element.innerHTML = newHTML
    })
  }
}
